"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var antd_1 = require("antd");
var formik_1 = require("formik");
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var utils_1 = require("../../../utils/utils");
var Field_1 = __importDefault(require("../components/Field"));
var CheckboxWrapper = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  align-self: center;\n  @media only screen and (max-width: 500px) {\n    margin-bottom: 8px;\n  }\n"], ["\n  display: flex;\n  align-self: center;\n  @media only screen and (max-width: 500px) {\n    margin-bottom: 8px;\n  }\n"])));
var StyledCheckbox = styled_components_1.default(antd_1.Checkbox)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  .ant-checkbox-inner {\n    width: 20px;\n    height: 20px;\n    border-radius: 3px;\n    border: 2px solid #2362a2;\n    outline: none;\n  }\n  .ant-radio-input:focus + .ant-radio-inner {\n    box-shadow: none;\n    outline: none;\n  }\n  &.ant-checkbox-wrapper {\n    align-items: center;\n    & > *:last-child {\n      font-size: 12px;\n      font-weight: 500;\n      padding-left: 15px;\n      color: #3b3b3b;\n      text-transform: uppercase;\n      margin-top: 8px;\n    }\n  }\n"], ["\n  .ant-checkbox-inner {\n    width: 20px;\n    height: 20px;\n    border-radius: 3px;\n    border: 2px solid #2362a2;\n    outline: none;\n  }\n  .ant-radio-input:focus + .ant-radio-inner {\n    box-shadow: none;\n    outline: none;\n  }\n  &.ant-checkbox-wrapper {\n    align-items: center;\n    & > *:last-child {\n      font-size: 12px;\n      font-weight: 500;\n      padding-left: 15px;\n      color: #3b3b3b;\n      text-transform: uppercase;\n      margin-top: 8px;\n    }\n  }\n"])));
var CheckboxField = function (_a) {
    var name = _a.name, label = _a.label, onClick = _a.onClick, readOnly = _a.readOnly, checked = _a.checked, noGap = _a.noGap;
    var field = formik_1.useField(name)[0];
    return (react_1.default.createElement(Field_1.default, { noStyles: noGap },
        react_1.default.createElement("div", null),
        react_1.default.createElement(CheckboxWrapper, null,
            react_1.default.createElement(StyledCheckbox, __assign({}, field, { checked: checked || field.value, name: name, type: "checkbox", onClick: onClick, disabled: readOnly, id: utils_1.NormalizeString(name) }), label))));
};
CheckboxField.defaultProps = {
    onClick: undefined,
    readOnly: undefined,
    checked: undefined,
    noGap: undefined,
};
exports.default = CheckboxField;
var templateObject_1, templateObject_2;
